import React, { MutableRefObject, useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';

import BookmarkIcon from '../../../assets/icons/BookmarkIcon.svg';
import { BookmarkIcon as GoToBookmarkIcon } from '../../icon/solid';
import { StudioControlStyles } from '../styles';
import { Button } from '../..';
import {
  setBookmarkPosition,
  setBookmarkAction,
  setRestartPrompter,
  restartRecordingCamera,
} from '../../../store/modules/studio/actions';
import { notify } from '../../../store/modules/notifications/actions';
import {
  selectBookmarkPosition,
  selectBookmarkAction,
  selectIsPlayPrompter, selectCameraRecording,
} from '../../../store/modules/studio/selectors';
import StudioToolTip from './StudioToolTip';

type Props = {
  refPrompter: MutableRefObject<HTMLDivElement | null>;
};

const BookMarkAction = ({ refPrompter }: Props) => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const bookMarkPosition = useSelector(selectBookmarkPosition);
  const isActive = useSelector(selectBookmarkAction);
  const isPlay = useSelector(selectIsPlayPrompter);
  const isRecording = useSelector(selectCameraRecording);

  const onStoreBookmark = useCallback((e: React.MouseEvent) => {
    if (refPrompter.current) {
      const { scrollTop } = refPrompter.current;
      dispatch(setBookmarkPosition(scrollTop || 0));
      dispatch(setBookmarkAction(true));
      dispatch(notify({
        type: 'custom',
        message: (
          <Grid container alignItems="center" spacing={1} className={classes.notify}>
            <Grid item>
              <img src={BookmarkIcon} alt="" className={classes.bookmarkIcon} />
            </Grid>
            <Grid item>
              <span>Bookmark saved</span>
            </Grid>
          </Grid>
        ),
      }));
    }
  }, [dispatch, refPrompter, classes]);

  const onGoToBookmark = useCallback((e: React.MouseEvent) => {
    if (window.requestPrompterPosition) {
      window.requestPrompterPosition(e, bookMarkPosition || 0);
    }
    if(isRecording){
      dispatch(restartRecordingCamera());
    }else if (isPlay) {
      dispatch(setRestartPrompter());
    }
  }, [dispatch, bookMarkPosition, isPlay, isRecording]);

  return (
    <>
      <Grid item className={classes.smallButtonContainer}>
        <StudioToolTip title="Add a bookmark at this script location">
          <Button
            onClick={onStoreBookmark}
            className={classes.button}
            data-intercom-target="Button: Add bookmark"
          >
            <img src={BookmarkIcon} alt="" className={classes.bookmarkIcon} />
          </Button>
        </StudioToolTip>
      </Grid>
      {
        bookMarkPosition !== null
        && (
          <Grid item className={classes.smallButtonContainer}>
            <StudioToolTip title="Go to the last bookmark that was set">
              <Button
                onClick={onGoToBookmark}
                className={clsx(classes.button, isActive ? classes.activeButton : '')}
                data-intercom-target="Button: Go to bookmark"
              >
                <GoToBookmarkIcon className={classes.icon} />
              </Button>
            </StudioToolTip>
          </Grid>
        )
      }
    </>
  );
};

export default BookMarkAction;
